var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Polygon_icon",
    "data-name": "Polygon icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    rx: 12,
    transform: "translate(0 32) rotate(-90)",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(6.678 7.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M17.981,7.28,14.148,5.052a1.3,1.3,0,0,0-1.3,0Q9.215,7.163,5.581,9.269a.941.941,0,0,1-.946,0l-2.3-1.338a.941.941,0,0,1-.468-.814V4.431a.941.941,0,0,1,.468-.814l2.3-1.338a.941.941,0,0,1,.946,0l2.3,1.338a.941.941,0,0,1,.468.814V6.174l1.886-1.091V3.538a1.3,1.3,0,0,0-.644-1.119L5.759.191a1.3,1.3,0,0,0-1.3,0L.625,2.419A1.3,1.3,0,0,0-.02,3.538V8.01A1.294,1.294,0,0,0,.625,9.129l3.833,2.228a1.3,1.3,0,0,0,1.3,0Q9.392,9.25,13.024,7.141a.941.941,0,0,1,.946,0l2.3,1.338a.941.941,0,0,1,.468.814v2.687a.941.941,0,0,1-.468.814l-2.3,1.338a.941.941,0,0,1-.946,0l-2.3-1.338a.941.941,0,0,1-.468-.814V10.235L8.37,11.326v1.545a1.3,1.3,0,0,0,.644,1.119l3.833,2.228a1.3,1.3,0,0,0,1.3,0l3.833-2.228a1.3,1.3,0,0,0,.644-1.119V8.4a1.3,1.3,0,0,0-.644-1.119Z",
    transform: "translate(0.02 -0.015)",
    fill: "#904dff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.424dacb25e020791ed665086f7fe87a4.svg";
export { ForwardRef as ReactComponent };